import { render } from "./InputTel.vue?vue&type=template&id=2b03c027&scoped=true"
import script from "./InputTel.vue?vue&type=script&lang=js"
export * from "./InputTel.vue?vue&type=script&lang=js"

import "./InputTel.vue?vue&type=style&index=0&id=2b03c027&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b03c027"]])

export default __exports__